<template>
  <div
    :class="['ui-select', { error: error, required: requiredField }]"
    tabindex="1"
    @blur="visibleOptions = false"
  >
    <div v-if="label" class="ui-select__label">
      {{ error ? errorText || label : label }}
    </div>
    <div
      @click="openOptions"
      :class="['ui-select__inner', { active: visibleOptions }]"
    >
      <div class="ui-select__inner-text">
        {{
          modelValue?.text
            ? modelValue.text
            : modelValue
              ? modelValue
              : placeholder
        }}
      </div>
      <img
        src="@/assets/img/arrow-down.svg"
        alt=""
        :class="{ 'ui-select__inner-arrow': greyArrow }"
      />
    </div>
    <transition name="slide-bottom">
      <div v-if="visibleOptions" class="ui-select__options">
        <div
          v-for="(item, key) in options"
          :key="key"
          @click="changeValue(item)"
          :class="[
            'ui-select__options-item',
            {
              active:
                (modelValue?.text === item.text && item.text) ||
                modelValue === item,
            },
          ]"
        >
          {{ item.text || item }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UiSelect',

  props: {
    modelValue: {
      type: [String, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    requiredField: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    greyArrow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visibleOptions: false,
    }
  },
  methods: {
    changeValue(val) {
      this.$emit('update:modelValue', val)
      this.visibleOptions = false
    },

    openOptions() {
      if (!this.disabled) {
        this.visibleOptions = !this.visibleOptions
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-select {
  position: relative;
  width: 100%;
  outline: none;
  user-select: none;

  &.required {
    .ui-select__label:after {
      content: '*';
      color: #e21f1f;
    }
  }

  &.error {
    .ui-select__label {
      color: #e21f1f;
    }

    .ui-select__inner {
      border-color: #e21f1f;
    }
  }

  &__label {
    color: #75828b;
    margin-bottom: 6px;
  }

  &__inner {
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #d1d8dd;
    border-radius: 6px;
    padding: 8px 10px 8px 15px;
    font-weight: 400;
    cursor: pointer;
    color: #39444c;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.224px;
    transition: 0.3s;

    @media (max-width: 480px) {
      border: 1px solid #d1d8dd;
      border-radius: 8px;
    }

    img {
      transition: 0.3s;
    }

    &:hover {
      background: #f3f8fc;
    }

    &.active {
      border: 2px solid #8e9aa4;
      outline: none;

      @media (max-width: 480px) {
        border: 1px solid #858c91;
      }

      img {
        transform: rotate(180deg);
      }
    }

    &-arrow {
      filter: opacity(0.5);
      width: 20px;
    }
  }

  &__options {
    position: absolute;
    top: 51px;
    max-height: 198px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    overflow-y: auto;
    z-index: 100000;
    border-radius: 8px;
    border: 1px solid #e5ecf1;
    background: #fff;
    box-shadow:
      0 8px 16px -4px rgba(4, 51, 103, 0.11),
      0px 2px 8px -2px rgba(0, 80, 178, 0.06);

    &-item {
      font-weight: 400;
      cursor: pointer;
      color: #39444c;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.224px;
      height: 44px;
      padding: 10px 12px;

      &.active {
        background: #e8ecf0;

        &:hover {
          background: #d4dbe3;
        }
      }

      &:hover {
        background: #e8ecf0;
      }
    }
  }
}
</style>
